<template>
  <!-- 选择支付方式 -->
  <div
    v-if="h_visible"
    class="containerr flex_layout flex_xy_center"
    @click.self="clickClosemask"
    @touchmove.stop.prevent
  >
    <transition name="fade">
      <div v-if="h_transition">
        <div class="payment-container">
          <div class="payment-title flex_layout flex_xy_center">
            选择支付方式
          </div> 
          <div class="payment-detail">
            <p class="detail-title">
              {{ good_title }}（充值账号：{{ nickname }}）
            </p> 
            <p class="detail-price">
              <span class="money-icon">￥</span>{{ good_price | formatFenToYuan }}
            </p>
          </div> 
          <ul class="detail-list-container">
            <li
              v-for="(item,index) in paytypes"
              :key="'type'+index"
              class="detail-list flex_layout flex_y_center flex_x_spacebetween"
              @click="clickPay(item.pay_type)"
            >
              <div class="flex_layout flex_xy_center">
                <img
                  :src="item.icon_url"
                  class="payment-icon"
                > 
                <div class="flex_layout flex_flexDirection_column">
                  <div>
                    <span class="payment-name">{{ item.title }}</span>
                    <img
                      v-show="item.activity_icon_url"
                      :src="item.activity_icon_url"
                      class="payment-icon-activity"
                    >
                  </div>
                  <div v-if="((item.pay_type==10 || item.pay_type==11) && item.activity_icon_url)">
                    <span class="payment-descriptionweixin">亿万用户的选择，更快更安全</span>
                  </div>
                </div>
              </div> 
              <div class="flex_layout flex_xy_center">
                <span class="payment-description">{{ item.description }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="detail-close-btn flex_layout flex_xy_center">
          <span @click.self="clickClosemask" />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import {ua, qs} from "@/assets/fe_js/common/base/fn/browser";
import {getDeepVal} from "@/assets/fe_js/common/base/fn/object";
import {miniprogramNav} from "@/assets/fe_js/common/miniprogram/utils";
import {jump_middle_page} from "../../js/utils.js";
export default {
    name: "Payment",
    filters:{
        formatFenToYuan:function(money){
            if (!money) return money;
            money = (money*0.01).toFixed(2);
            return (/.00/.test(money)) ? parseInt(money) : money;
        },
    },
    props: {
        dialogname: {
            type: String,
            default: ""
        },
        api_goodsdata:{
            type: Object,
            default: () => {
                return {};
            }
        },
        req_data:{
            type: Object,
            default: () => {
                return {};
            }
        },
    },
    data() {
        return {
            h_visible : false,
            h_transition : false,
            good_title : "",
            good_price : 0,
            props_api_goodsdata: this.api_goodsdata
        };
    },
    computed: {
        request_id(){
            return getDeepVal(this.props_api_goodsdata,"request_id","");
        },
        nickname(){
            return getDeepVal(this.props_api_goodsdata,"user.nickname","");
        },
        paytypes(){
            /*设置支付方式
                9    支付宝－支付宝h5
                10   微信支付－微信公众号 - 需使用oauth2 url方式打开 使用微信sdk
                11   微信支付－微信h5   - 直接调用微信支付url
                12   QQ支付－腾讯公众号 - qq客户端里可用qqsdk , jsapi实现QQ支付
                14   QQ支付－腾讯h5    - 呼起shceme的方式掉用QQ支付-其实是腾讯的url地址与支付宝一样
            */
            let paytypes = getDeepVal(this.props_api_goodsdata,"members.0.pay_types",[]);
            let vtypes = {
                "weixin"    : [10],
                "alipay"    : [9],
                "qqnative"  : [12],
                "qqbrowser"   : [9, 11, 14],
                "browser"   : [9, 11],
            };
            let current_ua  = ua.weixin ? "weixin" : ua.alipay ? "alipay" : ua.qqnative ? "qqnative" :  ua.qq ? "qqbrowser": "browser";
            let types       = vtypes[current_ua];
            let res         = [];
            paytypes.forEach(function(item){
                types.forEach(function(sitem){
                    if (item.pay_type == sitem) {
                        res.push(item);
                    }  
                });
            });
            this.good_select();
            return res;
        }
    },
    watch:{
        dialogname:{
            handler(val){
                if(val == "dialog-poppayment" || val == "dialog-poppayment-child") {
                    this.openmask();
                } else {
                    this.closemask();
                }
            },
            deep:true
        },
    },
    methods: {
        // 父组件调用，可以预取或刷新数据
        refresh() {
            if (!this.checkPropsParam("pre")) return null;
            getH5Membergoods(this.getParam())
                .then(res => {
                    let {code, data={}, message=""} = res;
                    this.props_api_goodsdata = data;
                    this.sendMessage(res);
                })
                .catch(error => {
                    this.sendMessageBefore(-1, "getGoodsList():["+error+"]");
                });
        },
        clickPay(pay_type){
            let V_PARAM = {
                ...this.req_data,
                pay_type,
                request_id : this.request_id,
            };
            jump_middle_page(V_PARAM);
        },
        good_select(){
            let recharge_goods = getDeepVal(this.props_api_goodsdata,"members.0.recharge_goods",[]);
            let renew_goods = getDeepVal(this.props_api_goodsdata,"members.0.renew_goods",[]);
            let goods = renew_goods.concat(recharge_goods);
            goods.forEach((item) => {
                if(item.id == this.req_data.good_id) {
                    this.good_title = item.title;  
                    this.good_price = item.real_price;
                    let coupons = getDeepVal(item,"coupon.usable_list",[]);
                    if (this.req_data.coupon_id > 0 &&  coupons.length > 0) {
                        coupons.forEach((v, k) => {
                            if(v.id == this.req_data.coupon_id) {
                                this.good_price = item.real_price - v.amount;
                            }
                        });
                    }
                }
            });
            return null;
        },
        isMiniprogram(){
            if (ua.miniprogram) {
                let V_PARAM = {
                    ...this.req_data,
                    pay_source   : 2,//1.我的钱包(客户端) 2.活动页(h5)
                };
                let url = "/pages/directpay/directpay?v_param="+encodeURIComponent(JSON.stringify(V_PARAM))+"&t="+new Date().getTime();
                // url = '/pages/buyvip/buyvip?v_param='+encodeURIComponent(JSON.stringify(V_PARAM))+'&t='+new Date().getTime();
                miniprogramNav(url);
                this.clickClosemask();
                return true;
            }
            return false;
            
        },
        openmask(){
            if (this.isMiniprogram()) {
                return null;
            }
            this.h_visible = true;
            this.$nextTick(() => {
                this.h_transition = this.h_visible;
            });
        },
        closemask(){
            this.h_transition = false;
            setTimeout(() => {
                this.h_visible = false;
            },300);
        },
        clickClosemask(){
            this.$emit("close");
        },
    }
};

</script>
<style lang="scss" scoped>
@import "@/assets/sass/vws.scss";

.containerr, .containerr * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    font-size:18px;
}
.containerr{
    position:fixed;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,.5);
    z-index:9999;
}
.payment-container {
    width: 270px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .payment-title {
        width: 100%;
        height: 50px;
        font-size: 14px;
        color: #000;
    }
    .payment-detail {
        width: 100%;
        background-color: #F7F9FA;
        overflow: hidden;
        .detail-title {
            font-size: 14px;
            color: #999;
            line-height: 14px;
            margin-top: 22px;
            text-align: center;
            padding: 0 10px;
        }
        .detail-price {
            font-size: 32px;
            color: #666;
            margin-top: 8px;
            text-align: center;
            .money-icon {
                margin-right: 4px;
            }
        }
    }
    .detail-list-container {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        overflow: hidden;
        .detail-list {
            width: 100%;
            height: 46px;
            border-bottom: 1px solid #eee;
            list-style: none;
            .payment-icon {
                width: 20px;
                height: 20px;
                display: inline-block;
                margin-left: 18px;
            }
            .payment-icon-activity {
                height: 20px;
                width: auto;
                display: inline-block;
                margin-left: 2px;
                vertical-align: middle;
            }
            .payment-description {
                font-size: 12px;
                color:#999;
                margin-right: 10px;
            }
            .payment-descriptionweixin {
                font-size: 12px;
                color: #999;
                transform: scale(.6) translateX(-25%);
                display: block;
            }
            .payment-name {
                font-size: 14px;
                line-height: 14px;
                color: #333;
                margin-left: 8px;
            }
        }
    }
}
.detail-close-btn {
    padding-top:20px;
    span{
        width: 27px;
        height: 27px;
        display: inline-block;
        background-image: url(https://static3w.kuaikanmanhua.com/assets/img/pay/close-icon_0690bfa.png);
        background-size: 100% 100%; 
    }
}

@media (max-width:320px) { 
    .payment-container{
        width: 230px;
    }
}
</style>








// WEBPACK FOOTER //
// src/components/web/pay/comp/poppayment/main.vue